import type { Locale } from 'config/constants/locales';

export const NEXT_DEFAULT_LOCALE = 'default';
export const NEXT_LOCALES = ['de', 'en', 'nl'] as const;

export const getNextRouterLocale = (locale: Locale, defaultLocale: Locale): string => {
  if (locale === defaultLocale) return NEXT_DEFAULT_LOCALE;

  return NEXT_LOCALES.includes(locale as (typeof NEXT_LOCALES)[number])
    ? locale
    : NEXT_DEFAULT_LOCALE;
};
